import URI from "urijs";
import ITocItem from "../models/ITocItem";
import IContentsItem from "../models/IContentsItem";
import transformDocUrl from "./transformDocUrl";

const isSelected = (item: IContentsItem, contentId: string): boolean => {
  const { href } = item;
  const curHref = URI("/docs").addSearch("id", contentId);

  return curHref.toString().toLowerCase() === (href || "").toLowerCase();
};

const markOpenAndSelected = (item: IContentsItem, contentId: string): boolean => {
  let isChildSelected: boolean = false;
  const { items } = item;

  if (items) {
    for (let i = 0; i < items.length; i++) {
      if (markOpenAndSelected(items[i], contentId)) {
        isChildSelected = true;
      }
    }
  }
  item.isSelected = isSelected(item, contentId);
  item.isOpen = isChildSelected || item.isSelected;
  return item.isOpen;
};

const transformChildren = (children: ITocItem[], tocId: string, contentId: string): IContentsItem[] => {
  let contents: IContentsItem[] = [];

  if (children) {
    for (let i = 0; i < children.length; i++) {
      const { href, name, items, leaf, level } = children[i];

      let url = transformDocUrl(href, tocId);
      if (url) {
        url = url.toLowerCase();
      }
      contents.push({
        name,
        href: url,
        items: transformChildren(items, tocId, contentId),
        level,
        leaf,
        isSelected: false,
        isOpen: false,
      });
    }
  }

  return contents;
};

const transformToc = (items: ITocItem[], tocId: string, contentId: string): IContentsItem[] => {
  let contents: IContentsItem[] = transformChildren(items, tocId, contentId);

  for (let i = 0; i < contents.length; i++) {
    markOpenAndSelected(contents[i], contentId);
  }

  return contents;
};

export default transformToc;
